"use strict";
/**
 * Created on 05 17 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * <p>Stores the <b>real</b> start of an application recalculation. Helps determine the date to which an application is recalculated.</p>
 *
 * <p>During night recalculation, we have to recalculate data for a certain day within some parts of the application. So that we can
 * decide on this day, it is useful to know when the last recalculation of the application started. This saved last start should always
 * be written to the DB when the night recalculation starts. The date to which the application is recalculated will be decided along with
 * this date and the opening date in the configuration, see {@link ApplicationRecalculation.appRecalcTo}.</p>
 *
 * @author JMe
 */


var AppRecalcInitiation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AppRecalcInitiation, _DomainObject_1$Domai);

  /**
   * Ctor.
   * @param id Internal id of a storage record.
   * @param initiated Moment of recalculation initiation.
   */
  function AppRecalcInitiation(id, initiated) {
    var _this;

    _classCallCheck(this, AppRecalcInitiation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppRecalcInitiation).call(this));
    _this.id = id;
    _this.initiated = initiated;
    return _this;
  }

  return AppRecalcInitiation;
}(DomainObject_1.DomainObject);

exports.AppRecalcInitiation = AppRecalcInitiation;